export const setCookie = (cookieName, value, days) => {
	var expires = "";
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		expires = "; expires=" + date.toUTCString();
	}
	document.cookie = cookieName + "=" + (value || "") + expires + "; path=/";
};

export const getCookie = (cookieName) => {
	var nameEQ = cookieName + "=";
	var ca = document.cookie.split(";");
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) === " ") c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
	}
	return null;
};
export const eraseCookie = (cookieName) => {
	document.cookie =
		cookieName + "=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
};
